import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Primitive, styled } from '@miro-site/ui-styled-engine';
import { variantsStyles, variantsTypesStyles } from '../typography/Typography.styled';
var LinkStyled = styled(Primitive.a, _objectSpread(_objectSpread(_objectSpread({
  position: 'relative',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  $$linkIdleColor: '$colors$font-default-idle',
  $$linkHoverColor: '$colors$font-default-hover',
  $$linkActiveColor: '$colors$font-default-active',
  textDecoration: 'none'
}, variantsTypesStyles['body-text']), variantsStyles['body-text-1']), {}, {
  color: '$$linkIdleColor',
  '& svg': {
    width: '$icon-300',
    color: '$$linkIdleColor'
  },
  '&:hover': {
    color: '$$linkHoverColor',
    '& svg': {
      color: '$$linkHoverColor'
    }
  },
  '&:active': {
    color: '$$linkActiveColor',
    '& svg': {
      color: '$$linkActiveColor'
    }
  },
  '&:hover, &:active': {
    textDecoration: 'underline'
  },
  '.keyboard-a11y &:focus': {
    outline: '$border-widths$lg solid $focus-ring-default',
    borderRadius: '$50'
  },
  variants: {
    disabled: {
      "true": {
        pointerEvents: 'none',
        $$linkIdleColor: '$colors$font-default-disabled'
      }
    },
    variant: {
      "default": {
        $$linkIdleColor: '$colors$font-default-idle',
        $$linkHoverColor: '$colors$font-default-hover',
        $$linkActiveColor: '$colors$font-default-active'
      },
      light: {
        $$linkIdleColor: '$colors$font-primary',
        $$linkHoverColor: '$colors$font-default-hover',
        $$linkActiveColor: '$colors$font-default-active'
      },
      dark: {
        $$linkIdleColor: '$colors$font-tertiary',
        $$linkHoverColor: '$colors$font-tertiary',
        $$linkActiveColor: '$colors$font-tertiary'
      }
    },
    startIcon: {
      "true": {
        '& svg:first-of-type': {
          offsetRight: '$50'
        }
      }
    },
    endIcon: {
      "true": {
        '& svg:last-of-type': {
          offsetLeft: '$50'
        }
      }
    }
  },
  defaultVariants: {
    variant: 'default'
  }
}));
export default LinkStyled;